import { gsap } from 'gsap';
import Swiper from 'swiper';
import { SwiperElementType } from '..';

const components: NodeListOf<Element> =
  document.querySelectorAll('.value-proposition');

export class ValueProposition {
  constructor() {}

  startAutoPlay(element: HTMLElement, swiperData: SwiperElementType) {
    swiperData.swiper.autoplay.start();
  }
}
